import React from "react";
import {TooltipPortal, TooltipPopover} from "../base/tooltip/tooltip";

class CustomCheckboxField extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            className: this.props.className || "",
            position: this.props.position || 'left',
            id: this.props.id || this.props.name,
            sizes: this.props.sizes || [12,10],
            showTooltip: false
        };

        this.tooltipRef = React.createRef();
    }

    newsletterTooltip = () => {
        return (<TooltipPortal areaRef={this.tooltipRef}>
            <TooltipPopover>
                <span>HRAddict's newsletter is sent 3x weekly and delivers HR hacks, latest trends and resources! Unsubscribe anytime, it's FREE!</span>
            </TooltipPopover>
        </TooltipPortal>);
    };

    render() {
        return (
            <div className={this.state.className}>
                {this.state.showTooltip && this.newsletterTooltip()}
                <label ref={this.tooltipRef}
                       onMouseOver={() => {
                           this.setState({showTooltip: true});
                       }}
                       onMouseLeave={() => {
                           this.setState({showTooltip: false});
                       }} className={'relative-checkbox'}>
                    <input
                        type="checkbox"
                        value={this.props.value || false}
                        onChange={this.props.onChange}
                        name={this.props.name}
                        checked={this.props.value || false}
                        disabled={this.props.disabled || false}
                        className="custom-checkbox-input"
                        id={this.state.id}
                    />

                    <div className={"custom-checkbox" + (this.props.value ? ' checked' : '') + (this.props.disabled ? ' disabled' : '')}>
                        {this.props.useTickMark ?
                            <div className={'tick-mark'}/>
                            :
                            <svg width="12px" height="10px" viewBox="0 0 12 10">
                                <polyline points="1.5 6 4.5 9 10.5 1"/>
                            </svg>
                        }
                    </div>
                    <b>Subscribe to our 3x weekly <a className={'secondary-link'} href={'https://newsletter.hraddict.com/'} target={'_blank'}>newsletter</a> (Optional)</b>
                </label>
            </div>
        )
    }
}
export default CustomCheckboxField;